import { authApi } from '@wellesley/auth/authApi'
import { authToken } from '@wellesley/auth/helpers/token'
import { type Action, type AnyAction } from '@reduxjs/toolkit'
import { getStore } from '@wellesley/store'
import { type PostApiV1AccountsUserReselectUserApiArg } from '@wellesley/openapi'
import { reselectUser, requestLogout, askLoginAction } from '../../api/actions'
import { authSlice } from '@wellesley/auth/authSlice'

const hostApi = {
  [askLoginAction.type]: () =>
    getStore().dispatch(authSlice.actions.setAskLoginOpen(true)),
  [reselectUser.type]: (arg: PostApiV1AccountsUserReselectUserApiArg) =>
    getStore().dispatch(
      authApi.endpoints.postApiV1AccountsUserReselectUser.initiate(arg),
    ),
  [requestLogout.type]: () => authToken.removeToken(),
}

const isHostApiAction = (action: Action) =>
  Object.keys(hostApi).includes(action.type)

type Arg = Parameters<(typeof hostApi)[keyof typeof hostApi]>[0]
export const callHostApiAction = (action: AnyAction) =>
  isHostApiAction(action)
    ? (hostApi[action.type] as unknown as (arg: Arg) => void)(
        action.payload as Arg,
      )
    : null
